import { RefObject, useEffect, useState } from 'react';

/**
 * 要素が一度でもビューポートに入ったかどうかを返すフック。
 *
 * メッセージ一覧など多数のプレイヤーが並ぶ画面で、画面外の要素まで
 * 一斉に decode フォールバックが走るのを防ぐために使う（可視化までの遅延ゲート）。
 * 一度 true になったら監視を止め、以後 false には戻らない。
 */
export function useVisibleOnce(ref: RefObject<Element | null>): boolean {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible) return;
    const el = ref.current;
    if (!el) return;

    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setVisible(true);
        observer.disconnect();
      }
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, visible]);

  return visible;
}
